import React from "react";
import { EnrichedSwarovskiProductFrontendProductReview, SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { css } from "@emotion/react";
import { PDPReviewComment } from "./PDPReviewComment";
import { PDPReviewCommentTopBar } from "./PDPReviewCommentTopBar";
import { ReviewTranslations } from "./reviewTranslations";
import { PDPReviewCommentReplies } from "./PDPReviewCommentReplies";

type RelativeTimeFormatUnit = Parameters<Intl.RelativeTimeFormat["format"]>[1];
export type TimeAgoFormat = { tag: RelativeTimeFormatUnit; value: number };

export const PDPReviewsDetailsReviewsListElement: React.FC<{
  review: EnrichedSwarovskiProductFrontendProductReview;
  reviewDateFormatter: (createdDateIsoString: string) => string;
  t: ReviewTranslations;
}> = ({ review, reviewDateFormatter, t }) => {
  return (
    <div>
      <div
        className="so-bg-gray2024-light"
        css={css`
          padding: var(--p);
        `}
      >
        <PDPReviewCommentTopBar
          author={review.author}
          createdDateIsoString={review.createdDateIsoString}
          rating={review.rating}
          reviewDateFormatter={reviewDateFormatter}
        />

        <PDPReviewComment comment={review.comment} t={t} />
      </div>

      {review.replies && (
        <PDPReviewCommentReplies replies={review.replies} t={t} reviewDateFormatter={reviewDateFormatter} />
      )}
    </div>
  );
};
